var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    fill: "none",
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M6.4 0c-.418 0-.847.146-1.15.446-.303.298-.45.723-.45 1.137v.792H0v1.583h.8v12.667C.8 17.927 1.884 19 3.2 19h9.6c1.316 0 2.4-1.073 2.4-2.375V3.958h.8V2.375h-4.8v-.792c0-.414-.147-.838-.45-1.138C10.448.145 10.018 0 9.6 0H6.4zm0 1.583h3.2v.792H6.4v-.792zm-4 2.375h11.2v12.667c0 .44-.356.792-.8.792H3.2c-.444 0-.8-.353-.8-.792V3.958zM4 6.333v8.709h1.6V6.333H4zm3.2 0v8.709h1.6V6.333H7.2zm3.2 0v8.709H12V6.333h-1.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b47abb3aa98f0fde26be0dda76248e25.svg";
export { ForwardRef as ReactComponent };